import {
  Children,
  cloneElement,
  ComponentType,
  isValidElement,
  ReactNode,
  useMemo
} from 'react';
import { ModelFieldGroup } from '../components/models/ModelFieldGroup';

export interface UseRenderPathsOptions {
  // The renderer varies per call site (ModelFieldGroup / ModelFilter /
  // ModelDisplayGroup), each with a different prop shape, so the component type
  // is intentionally loose here.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component?: ComponentType<any>;
  // Pass-through props forwarded to each rendered path; their shape is dynamic.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props?: Record<string, any>;
}

export const useRenderPaths = (
  paths: ReactNode,
  options: UseRenderPathsOptions
) => {
  const { Component = ModelFieldGroup, props } = options;

  const renderPaths = useMemo(
    () =>
      // eslint-disable-next-line @eslint-react/no-children-map
      Children.map(paths, (path) =>
        isValidElement(path) ? (
          // eslint-disable-next-line @eslint-react/no-clone-element
          cloneElement(path, props)
        ) : (
          // Non-element children are attribute path strings here.
          <Component path={path as string} {...props} />
        )
      ),
    // eslint-disable-next-line @eslint-react/exhaustive-deps, react-hooks/exhaustive-deps
    [paths, props]
  );

  return renderPaths;
};
